import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EmailIntegrationService } from './../../_services/email-integration.service';

const frontendurl = environment.frontendurl;
@Component({
  selector: 'app-email-campaign-google-button',
  templateUrl: './email-campaign-google-button.component.html',
  styleUrls: ['./email-campaign-google-button.component.scss']
})
export class EmailCampaignGoogleButtonComponent implements OnInit {
  authurl: string
  @Output() gmailConnect: EventEmitter<any> = new EventEmitter();
  constructor(private emailintegrationservice: EmailIntegrationService) { }

  ngOnInit() {
  }
  //add function to print 'printing...' on pressing google button 
 
  connectoGmail(){
    let data ={
      "redirectionurl": `${frontendurl}/email_redirection?integrate=gmail`
    }
    this.emailintegrationservice.gmailintegrationurl(data).subscribe((res:any)=>{
      if(res.status == 'success'){
        this.authurl = res.url
        var winObj = window.open(this.authurl, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes');
        const loop = setInterval(() => {
          if (winObj && winObj.closed) {
            clearInterval(loop);
            this.gmailConnect.emit({ success: true, message: 'connected' });
          }
        }, 1000);
      }else{
        this.gmailConnect.emit({ success: false, error: res.message });
      }
    })
  }
}
